export const CALCULATIONS_STEPS_TITLES = {
    'CALCULATIONS.TIME_AND_BALANCE': 'Perioadă & balanță',
    'CALCULATIONS.BALANCE_SUMMARY': 'Sumar balanță',
    'CALCULATIONS.INCOME_AND_EXPENSES_SIMILAR_ELEMENTS': 'Elemente similare veniturilor / cheltuielilor',
    'CALCULATIONS.FISCAL_AMORTIZATION': 'Amortizare fiscală',
    'CALCULATIONS.LEGAL_SERVE': 'Rezerva legală',
    'CALCULATIONS.ADDITIONAL_RESEARCH_AND_DEVELOPMENT_DEDUCTION': 'Deducere suplimentară de cercetare-dezvoltare',
    'CALCULATIONS.NON_TAXABLE_INCOME': 'Venituri neimpozabile',
    'CALCULATIONS.PROTOCOL_EXPENSES': 'Cheltuieli de protocol',
    'CALCULATIONS.EXPENSES_WITH_PROVISIONS': 'Cheltuieli cu provizioanele',
    'CALCULATIONS.CAR_EXPENSES': 'Cheltuieli auto',
    'CALCULATIONS.SOCIAL_EXPENSES': 'Cheltuieli sociale',
    'CALCULATIONS.COST_OF_INDEBTEDNESS': 'Costul îndatorării',
    'CALCULATIONS.OTHER_NON_DEDUCTIBLE_EXPENSES': 'Alte cheltuieli nedeductibile',
    'CALCULATIONS.TAX_BEFORE_LOANS': 'Impozit înainte de credite',
    'CALCULATIONS.EXTERNAL_FISCAL_LOAN': 'Credit fiscal extern',
    'CALCULATIONS.REINVESTED_PROFIT': 'Profit reinvestit',
    'CALCULATIONS.SPONSORSHIP': 'Sponsorizare',
    'CALCULATIONS.PREVIEW_CALCULATION': 'Vizualizare calcul',
    'CALCULATIONS.PREVIEW_ANNUAL_STATEMENT': 'Vizualizare declarație anuală',
    'CALCULATIONS.PREVIEW_QUARTERLY_STATEMENT': 'Vizualizare declarație trimestrială',
    'CALCULATIONS.PREVIEW_RECTIFICATION_STATEMENT': 'Vizualizare declarație rectificativă'
};
